import { render, staticRenderFns } from "./InvoiceHeader.vue?vue&type=template&id=634ca66f&"
import script from "./InvoiceHeader.vue?vue&type=script&lang=ts&"
export * from "./InvoiceHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports